import { Input } from '@headlessui/react';
import { forwardRef } from 'react';
import { GlobalError } from 'react-hook-form';
import { cx } from '@/utils/cx';

export type TextInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: GlobalError;
};

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, error, required, ...props }, ref) => (
    <Input
      {...props}
      aria-required={required}
      className={cx(
        'focusable',
        'block w-full rounded-md border border-black/20 bg-white px-3 py-2 text-sm font-normal text-black',
        className,
        error && 'border-warning text-red-900',
      )}
      invalid={Boolean(error)}
      onKeyDown={(event) => {
        if (props.type === 'number') {
          if (['e', 'E', '+', '-'].includes(event.key)) {
            // prevent typing beyond min/max
            // prevent pasting text
            event.preventDefault();
          }
        }
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      }}
      ref={ref}
    />
  ),
);
